import { useEffect } from "react";

const UnsavedChangesGuard = ({ when }) => {
  useEffect(() => {
    if (!when) return undefined;
    const handler = (e) => {
      e.preventDefault();
      e.returnValue = "";
    };
    window.addEventListener("beforeunload", handler);
    return () => window.removeEventListener("beforeunload", handler);
  }, [when]);

  return null;
};

export default UnsavedChangesGuard;
